'use client'

/**
 * HeroVideo — the home hero's animated background video.
 *
 * A small (~130KB), looping glassmorphism clip, object-cover behind the hero.
 * Muted + playsInline + autoPlay so it starts everywhere without sound. Under
 * prefers-reduced-motion we pause it and let the poster frame stand in.
 * Decorative only (aria-hidden); a paper veil above it keeps text at AA.
 */

import { useEffect, useRef } from 'react'

export function HeroVideo() {
  const ref = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const v = ref.current
    if (!v) return
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      v.pause()
      v.currentTime = 0 // hold on the poster-equivalent first frame
    }
  }, [])

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      <video
        ref={ref}
        className="absolute inset-0 h-full w-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        poster="/hero-poster.jpg"
      >
        <source src="/hero-bg.mp4" type="video/mp4" />
      </video>
    </div>
  )
}
